module.exports = __webpack_public_path__ + "img/options.fc7dfe8e.svg";